import * as React from 'react';
import cx from 'classnames/bind';
import hubItemSkeletonStyles from './HubItemSkeleton.scss';
import type { HubItemSkeletonProps } from '../schema/HubItemSkeleton.types';

const classNames = cx.bind(hubItemSkeletonStyles);

export const HubItemSkeleton: React.FC<HubItemSkeletonProps> = props => {
    const { children, styles: propStyles } = props;

    const styles = propStyles ?? {};
    const { className } = styles;
    const hubClassName = classNames(hubItemSkeletonStyles.hubItemSkeletonContainer, className);

    return (
        <div aria-hidden className={hubClassName}>
            {children || (
                <>
                    {renderIcon(props)}
                    {renderText(props)}
                    {renderAdditionalInfo(props)}
                </>
            )}
        </div>
    );
};

const renderIcon = (props: HubItemSkeletonProps): React.ReactNode => {
    const { styles: propStyles } = props;
    const styles = propStyles || {};
    const { iconContainerStyles } = styles;
    return (
        <div className={classNames(hubItemSkeletonStyles.iconContainer, iconContainerStyles)}></div>
    );
};

const renderText = (props: HubItemSkeletonProps): React.ReactNode => {
    const { primaryText, secondaryText, tertiaryText, styles: propStyles } = props;
    const styles = propStyles || {};
    const { textContainerStyles, primaryTextStyles, secondaryTextStyles, tertiaryTextStyles } =
        styles;
    return (
        <div className={classNames(hubItemSkeletonStyles.textContainer, textContainerStyles)}>
            {primaryText && (
                <>
                    <span
                        aria-hidden
                        className={classNames(
                            hubItemSkeletonStyles.primaryText,
                            primaryTextStyles
                        )}>
                        {primaryText}
                    </span>
                    {secondaryText && (
                        <span
                            aria-hidden
                            className={classNames(
                                hubItemSkeletonStyles.secondaryText,
                                secondaryTextStyles
                            )}>
                            {secondaryText}
                        </span>
                    )}
                    {tertiaryText && (
                        <span
                            aria-hidden
                            className={classNames(
                                hubItemSkeletonStyles.tertiaryText,
                                tertiaryTextStyles
                            )}>
                            {tertiaryText}
                        </span>
                    )}
                </>
            )}
        </div>
    );
};

const renderAdditionalInfo = (props: HubItemSkeletonProps): React.ReactNode => {
    const { onRenderAdditionalInfo, styles: propStyles } = props;
    const styles = propStyles || {};
    const { additionalInfoContainerStyles } = styles;

    return onRenderAdditionalInfo ? (
        <div
            className={classNames(
                hubItemSkeletonStyles.additionalInfoContainer,
                additionalInfoContainerStyles
            )}>
            {onRenderAdditionalInfo()}
        </div>
    ) : null;
};
